// frontend/src/features/livestock/CheckDateBadge.tsx
import { Badge } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';

/**
 * A date from the file's or the upload's time, not the photo's own: worth a
 * look. Amber, with dark text (amber text on a light background reads poorly).
 */
export function CheckDateBadge(): JSX.Element {
  return (
    <Badge
      size="sm"
      color="yellow"
      variant="light"
      tt="none"
      fw={600}
      leftSection={<IconAlertTriangle size={12} color="var(--mantine-color-orange-8)" />}
      styles={{
        root: {
          color: 'var(--mantine-color-gray-8)',
          backgroundColor: 'var(--mantine-color-yellow-1)',
          flexShrink: 0,
        },
      }}
    >
      check date
    </Badge>
  );
}
